function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cluysx43da"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 23437",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon_Account_Grey",
    style: {
      clipPath: "url(#cluysx43da)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18842",
    d: "M-1.515-.8A6.719 6.719 0 0 1-4.2-1.34a7.056 7.056 0 0 1-2.213-1.491A6.942 6.942 0 0 1-7.9-5.035a6.755 6.755 0 0 1-.538-2.689 6.755 6.755 0 0 1 .538-2.69 6.981 6.981 0 0 1 1.491-2.208A6.981 6.981 0 0 1-4.2-14.113a6.755 6.755 0 0 1 2.689-.538 6.755 6.755 0 0 1 2.689.538 6.942 6.942 0 0 1 2.2 1.491 7.056 7.056 0 0 1 1.492 2.208 6.719 6.719 0 0 1 .541 2.689 6.719 6.719 0 0 1-.541 2.69 7.016 7.016 0 0 1-1.491 2.2 7.016 7.016 0 0 1-2.2 1.491A6.719 6.719 0 0 1-1.515-.8zm0-1.521a5.294 5.294 0 0 0 2.1-.418A5.363 5.363 0 0 0 2.306-3.9a5.543 5.543 0 0 0 1.162-1.73 5.242 5.242 0 0 0 .422-2.1 5.258 5.258 0 0 0-.422-2.1 5.5 5.5 0 0 0-1.162-1.72 5.39 5.39 0 0 0-1.72-1.162 5.294 5.294 0 0 0-2.1-.418 5.294 5.294 0 0 0-2.1.418A5.429 5.429 0 0 0-5.34-11.55 5.429 5.429 0 0 0-6.5-9.826a5.294 5.294 0 0 0-.418 2.1A5.277 5.277 0 0 0-6.5-5.63 5.468 5.468 0 0 0-5.34-3.9a5.4 5.4 0 0 0 1.723 1.162 5.294 5.294 0 0 0 2.102.419zm4.343-1.014A6.886 6.886 0 0 1 1.41-2.4a7.764 7.764 0 0 1-1.531.578 5.653 5.653 0 0 1-1.395.2 5.65 5.65 0 0 1-1.385-.2A7.818 7.818 0 0 1-4.437-2.4a6.69 6.69 0 0 1-1.414-.94l.027-.146a2.731 2.731 0 0 1 .843-.926A5.018 5.018 0 0 1-3.5-5.128a6.58 6.58 0 0 1 1.986-.279 6.628 6.628 0 0 1 2 .279 4.97 4.97 0 0 1 1.478.721 2.716 2.716 0 0 1 .84.933zm-4.343-3.141a2.15 2.15 0 0 1-1.162-.339 2.368 2.368 0 0 1-.82-.9 2.734 2.734 0 0 1-.309-1.278 2.443 2.443 0 0 1 .3-1.229 2.487 2.487 0 0 1 .83-.9 2.082 2.082 0 0 1 1.159-.339 2.077 2.077 0 0 1 1.162.339 2.5 2.5 0 0 1 .827.9 2.494 2.494 0 0 1 .31 1.229 2.674 2.674 0 0 1-.305 1.282 2.414 2.414 0 0 1-.824.911 2.063 2.063 0 0 1-1.168.324z",
    transform: "translate(9.688 15.73)",
    style: {
      fill: "#5d6775"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a6996a7e03ce876c7a25a10ee6bd2637.svg";
export { ForwardRef as ReactComponent };